module.exports = __webpack_public_path__ + "img/secKillBtn.460b4fb2.png";